"use client";

import { useSafeI18nDate } from "@/i18n/use-safe-i18n-date";

type DateCellProps = {
  date: string | null | undefined;
};

export const DateCell = ({ date }: DateCellProps) => {
  const { safeI18nDate } = useSafeI18nDate();

  if (!date) {
    return <time className="whitespace-nowrap">{"-"}</time>;
  }

  return (
    <time dateTime={date} className="whitespace-nowrap">
      {safeI18nDate(new Date(date), {
        year: "numeric",
        month: "short",
        day: "2-digit",
      })}
    </time>
  );
};
